jQuery(function($) {

    "use strict";

    // To prevent jshint errors
    /*global Modernizr:true */
    /*jshint devel:true */
    /*global $:false */

    // Locations Slider
    $('.slider-locations').slick({
        dots: true,
        infinite: true,
        arrows: false,
        adaptiveHeight: true
    });

    $('.next-slick').on('click', function(event) {
        event.preventDefault();
        $('.slider-locations').slick('slickNext');
    });

    $('.prev-slick').on('click', function(event) {
        event.preventDefault();
        $('.slider-locations').slick('slickPrev');
    });


}(jQuery));